import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Divider from '@material-ui/core/Divider';
import MAList from './maList';
import MSList from './msList';
import FlightList from './flightList';
import JetList from './jetList';
import Hidden from '@material-ui/core/Hidden';
import { navigate } from 'gatsby';
import ProductSelector from './productSelector';

const styles = (theme) => ({
    root: {
        width: '100%',
        maxWidth: 360,
        backgroundColor: theme.palette.background.paper,
        textAlign: 'left',
    },
    nested: {
        paddingLeft: '24px',
        //you will want to adjust the font size for sub headings here
    },
    auxlinks: {
        textDecoration: 'none',
    },
    drawerProductDropdown: {
        paddingLeft: '16px',
    },
});

//depending on the selected product a drawer will be provided
const getProductAccordion = (selectedProduct, handleDrawerToggle) => {
    switch (selectedProduct) {
        case 'manager-agents':
            return (
                <div>
                    <MAList handleDrawerToggle={handleDrawerToggle} />
                </div>
            );
        case 'flight':
            return (
                <div>
                    <FlightList handleDrawerToggle={handleDrawerToggle} />
                </div>
            );
        case 'media-shuttle':
            return (
                <div>
                    <MSList handleDrawerToggle={handleDrawerToggle} />
                </div>
            );
        case 'jet':
            return (
                <div>
                    <JetList handleDrawerToggle={handleDrawerToggle} />
                </div>
            );
        default:
            return <div />;
    }
};

class DrawerItems extends React.Component {
    state = {
        product: '',
    };

    handleChange = (event) => {
        this.setState({ product: event.target.value });
        navigate(event.target.value);
    };
    render() {
        const { classes, selectedProduct, handleDrawerToggle } = this.props;

        return (
            <List className={classes.root}>
                <Hidden lgUp implementation="css">
                    <ProductSelector classes={classes.drawerProductDropdown} handleDrawerToggle={handleDrawerToggle} />
                    <Divider />
                </Hidden>

                {getProductAccordion(selectedProduct, handleDrawerToggle)}

                <Hidden mdUp implementation="css">
                    <ListItem onClick={this.props.handleDrawerToggle} button>
                        <a
                            href="https://developer.signiant.com"
                            target="_blank"
                            className={classes.auxlinks}
                            rel="noreferrer"
                        >
                            <ListItemText primary="API Documentation" />
                        </a>
                    </ListItem>
                    <Divider />
                    <ListItem onClick={this.props.handleDrawerToggle} button>
                        <a
                            href="https://support.signiant.com"
                            target="_blank"
                            className={classes.auxlinks}
                            rel="noreferrer"
                        >
                            <ListItemText primary="Signiant Support" />
                        </a>
                    </ListItem>
                    <Divider />
                </Hidden>
            </List>
        );
    }
}

DrawerItems.propTypes = {
    classes: PropTypes.object.isRequired,
    selectedProduct: PropTypes.string.isRequired,
};

export default withStyles(styles)(DrawerItems);
